import React, { Component } from 'react';
import { message, Popconfirm, Card, Table, Form, Input, Button, Select, Row, Col, Spin, DatePicker } from 'antd';

import client from '../../feathers';
import requireAuth from "../requireAuth";
import Layout from "../layout";
import axios from 'axios';

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  fetchReceipts,
  pushReceipts,
  removeReceipts,
  updateMode,
  updateActiveReceipts,
  updateReceipts
} from '../../actions/actions-receipts';

const _ = require('lodash');
const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const formItemStyle = {
  style: { width: '300px' }
};
const text = 'Are you sure to delete this item?';

class ReceiptsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      img: '',
      mode: 'new',

      _id: '',
      confirmDirty: false,
      autoCompleteResult: [],
      accountAssetsDropdowns: [],
      accountExpensesDropdowns: [],
      suppliers: [],
      dataSource: [],
      mode: 'new',
      propertyunits: [],
      loading: false,
      count: 0,

      description: '',
      date: '',
      supplierId: '',
      supplierCode: '',

      receiptNo: '',
      subTotalAmount: '',
      taxAmount: '',

      //category
      category: '',
      debitledgerAccountId: '',

      imageUrl: '',
    }

    this.handleClick = this.handleClick.bind(this);
  }

  componentWillMount() {
    //generate dropdown category
    client.authenticate()
      .then((res) => {

        return client.service('ledger-accounts').find({
          query: {
            companyId: res.propertyId._id,
            //categories:{$in:['EXPENSES','ASSETS']},
            accountNo: { $nin: ['3000'] },
            $sort: {
              description: 1
            }
          }
        })
      })
      .then((res) => {
        this.setState({
          accountExpensesDropdowns: res.data,
        })
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          accountExpensesDropdowns: []
        })
      })

    this.handleGetSupplierDropdown();

  }

  //-------------------------------------------------------------------
  handleGetSupplierDropdown = () => {
    //generate suppliers dropdown
    client.authenticate()
      .then((res) => {

        return client.service('suppliers').find({
          query: {
            propertyId: res.propertyId._id,
            $populate: 'ledgerAccountId',
            $sort: {
              supplierCode: 1
            }
          }
        })
      })
      .then((res) => {
        this.setState({
          suppliers: res.data,
        });
      })
      .catch((err) => {
        console.log(err);
      })
  }
  //-------------------------------------------------------------------
  handleSaveMerchant = () => {

    client.authenticate()
      .then((res) => {

        return client.service('suppliers').create({
          name: this.state.newMerchant,
          propertyId: sessionStorage.getItem('companyId'),
        })
      })
      .then((res) => {
        this.setState({
          invoice: res,
          loading: false
        });
        message.success('New Merchant Added');
        this.handleGetSupplierDropdown();

        this.props.form.setFieldsValue({
          merchantName: res._id
        });
      })
      .catch((err) => {
        console.log(err);
        alert(err);
      })
  }
  //-------------------------------------------------------------------
  handleChange = (value) => {

    var result = this.state.suppliers.filter(obj => {
      return obj._id === value
    })
    this.setState({
      creditledgerAccountId: result[0].ledgerAccountId._id,
      creditledgerAccountName: result[0].ledgerAccountId.accountName,
      supplierCode: result[0].supplierCode,
      supplierId: value,
    });

    this.props.form.setFieldsValue({ creditledgerAccountId: result[0].ledgerAccountId.accountName });

  }

  handleChangeCategory = (e) => {

    var result = this.state.accountExpensesDropdowns.filter(obj => {
      return obj._id === e
    })
    this.setState({
      category: result[0].accountName,
      debitledgerAccountId: e,
    })
  }

  //-------------------------------------------------------------------
  handleSearch = (value) => {
    this.setState({
      newMerchant: value
    });
  }
  //-------------------------------------------------------------------
  handleChangeSubTotalAmt = (e) => {
    this.setState({
      subTotalAmount: e.target.value
    });
    typingTimeout: setTimeout(() => {
      this.handleChangeTotalAmt()
    }, 500)
  }
  //-------------------------------------------------------------------
  handleChangeTaxAmount = (e) => {
    this.setState({
      taxAmount: e.target.value
    });
    typingTimeout: setTimeout(() => {
      this.handleChangeTotalAmt()
    }, 500)
  }

  handleChangeTotalAmt = () => {

    this.setState({
      totalAmount: parseFloat(this.state.subTotalAmount) + parseFloat(this.state.taxAmount)
    });
    this.props.form.setFieldsValue({ totalAmount: this.state.totalAmount });

  }

  handleEdit(_id) {
    this.props.updateActiveReceipts('edit', _id)
  }

  handleView(_id) {
    this.props.updateActiveReceipts('view', _id)
  }

  handleManage(_id) {
    this.props.updateActiveReceipts('', _id)
  }

  showModal = () => {
    this.props.updateMode('new')
  }

  handleImage(img = null) {
    this.setState({
      visible: true,
      img: img
    });
  }

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  }

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  }

  handleFileUpload = (event) => {

    this.setState({ loading: true });

    let formData = new FormData();

    formData.append('image', event.target.files[0]);

    axios.post(`${client.io.io.uri}upload-receipts`,
      formData
      , {
        headers: {
          'Authorization': client.settings.storage.storage['feathers-jwt'],
          'Content-Type': 'multipart/form-data',
        }
      }
    ).then((res) => {

      this.props.form.setFieldsValue({
        file: res.data.imageUrl
      });
      this.setState({
        loading: false,
        imageUrl: res.data.imageUrl,
      });
      message.success('Upload Successful');
    })
      .catch((err) => {
        this.setState({ loading: false });
        console.log(err);
        message.error(err);
      })
  }

  //..............................................................................
  handleDeleteItem = (key) => {

    const dataSource = [...this.state.dataSource];
    this.setState({ dataSource: dataSource.filter(item => item.key !== key) });
  }

  handleClick = () => {
    const {
      key,
      imageUrl,
      date,
      supplierId,
      creditledgerAccountId,
      creditledgerAccountName,
      supplierCode,
      receiptNo,
      subTotalAmount,
      taxAmount,
      totalAmount,
      category,
      debitledgerAccountId,
      description
    } = this.state
    const newData = {
      key,
      imageUrl,
      date,
      supplierId,

      //supplier
      creditledgerAccountId,
      creditledgerAccountName,
      supplierCode,

      receiptNo,
      subTotalAmount,
      taxAmount,
      totalAmount,

      //category
      category,
      debitledgerAccountId,
      description
    };

    this.setState({
      dataSource: [...this.state.dataSource, newData],
      count: this.state.count + 1,
    });
    const dataSource = [...this.state.dataSource];

  }
  //..............................................................................
  handleSubmit = (e) => {
    e.preventDefault();


    if (this.state.dataSource.length === 0) {
      return message.error('No item is selected');
    }

    this.props.form.validateFields((err, values) => {
      if (!err) {


        axios.post(`${client.io.io.uri}supplier-Multiple-Invoice`,
          {
            invoiceItems: this.state.dataSource,
            propertyId: sessionStorage.getItem('companyId'),
          },
          {
            headers: { 'Authorization': client.settings.storage.storage['feathers-jwt'] },
          }
        )
          .then((res) => {
            // this.props.history.push('/invoices/view/'+res._id);
            message.success('Invoice Created');
          })
          .catch((err) => {
            console.log(err);
            alert(err);
          })

      }
    });
  }
  //..............................................................................

  handleChangeDate = (e) => {

    this.setState({
      date: e.target.value,
    })
  }

  handleChangeRemark = (e) => {

    this.setState({
      description: e.target.value,
    })
  }

  handleChangereceiptNo = (e) => {

    this.setState({
      receiptNo: e.target.value,
    })
  }

  //total amount function
  handleChangeTotalAmount = (e) => {

    this.setState({
      totalAmount: e.target.value,
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { accountExpensesDropdowns } = this.state;

    const columns = [
      {
        title: 'Amount',
        dataIndex: 'totalAmount',
        key: 'totalAmount',
      },
      {
        title: 'Category',
        dataIndex: 'category',
        key: 'category',
      }, 
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Action',
        key: 'action',
        render: (text, record) => (
          this.state.dataSource.length >= 1
            ? (
              <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDeleteItem(record.key)}>
                <a href="javascript:;">Delete</a>
              </Popconfirm>
            ) : null
        ),
      }
    ];

    return (
      <Layout>
        <Spin spinning={this.state.loading}>
          <Card
            title='Supplier Invoices'
            extra={<Button type="danger" onClick={this.handleSubmit}>Create</Button>}
          >
            <Form className="submit-form">

              <Row>
                <Col span={12}>
                  <FormItem
                    {...formItemLayout}
                    label="Upload"
                  >
                    <Input label='upload file' type='file' onChange={this.handleFileUpload} />
                  </FormItem>

                  <FormItem
                    {...formItemLayout}
                    label="File Name"
                    style={{ 'display': 'none' }}
                  >
                    {getFieldDecorator('imageUrl', {
                      rules: [{
                        required: false, message: 'Please Upload File!',
                      }],
                    })(
                      <Input style={{ 'display': 'none' }} disabled={true} placeholder="File Name" />
                    )}
                  </FormItem>

                  <FormItem
                    {...formItemLayout}
                    label="Date"
                  >
                    {getFieldDecorator('date', {
                      rules: [{
                        required: true, message: 'Please input date!',
                      }],
                    })(

                      <DatePicker onChange={this.handleChangeDate} />
                    )}
                  </FormItem>

                  <FormItem
                    {...formItemLayout}
                    label="Supplier"
                  >
                    {getFieldDecorator('supplierCode', {
                      rules: [{
                        required: true, message: 'Please select Supplier!',
                      }],
                    })(
                      <Select
                        showSearch
                        placeholder="Select a Supplier"
                        defaultActiveFirstOption={false}
                        //notFoundContent={[<Button onClick={this.handleSaveMerchant} type="danger">+</Button>,' Create a New Merchant']}
                        onChange={this.handleChange}
                        onSearch={this.handleSearch}
                        //optionFilterProp="children"
                        //filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        showArrow={false}
                      >
                        {this.state.suppliers.map(dropdown => (
                          <Option key={dropdown._id} value={dropdown._id}>
                            {dropdown.supplierCode + '-' + dropdown.name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </FormItem>

                  <FormItem
                    {...formItemLayout}
                    label="Supplier Account"
                  >
                    {getFieldDecorator('creditledgerAccountId', {
                      rules: [{
                        required: true, message: 'Please input Account!',
                      }],
                    })(
                      <Input value={this.state.creditledgerAccountId} disabled />
                    )}
                  </FormItem>

                  <FormItem
                    {...formItemLayout}
                    label="Receipt No."
                  >
                    {getFieldDecorator('receiptNo', {
                      rules: [{
                        required: true, message: 'Please input Invoice No.!',
                      }],
                    })(
                      <Input placeholder="INV0001" onChange={this.handleChangereceiptNo} />
                    )}
                  </FormItem>

                </Col>
                <Col span={12}>

                  <FormItem
                    {...formItemLayout}
                    label="Sub Total Amount"
                  >
                    {getFieldDecorator('amount', {
                      rules: [{
                        required: true, message: 'Please input SubTotal!',
                      }],
                    })(
                      <Input placeholder="9.00" value={this.state.SubTotalAmount} onChange={this.handleChangeSubTotalAmt} />
                    )}
                  </FormItem>

                  <FormItem key='totalAmount'
                    {...formItemLayout}
                    label="Total Amount"
                  >
                    {getFieldDecorator('totalAmount', {
                      rules: [{
                        required: true, message: 'Please input Amount!',
                      }],
                    })(
                      <Input disabled onChange={this.handleChangeTotalAmount} />
                    )}
                  </FormItem>

                  <FormItem
                    {...formItemLayout}
                    label="Category"
                  >
                    {getFieldDecorator('debitledgerAccountId', {
                      rules: [{
                        required: true, message: 'Please input category!',
                      }],
                    })(
                      <Select placeholder="Please select category" onChange={this.handleChangeCategory}>
                        {accountExpensesDropdowns.map(dropdown => (
                          <Option key={dropdown._id} value={dropdown._id}>
                            {dropdown.description}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </FormItem>

                  <FormItem
                    {...formItemLayout}
                    label="Remark"
                  >
                    {getFieldDecorator('description', {
                      rules: [{
                        required: false, message: 'Please input remark!',
                      }],
                    })(
                      <TextArea rows={4} onChange={this.handleChangeRemark} />
                    )}
                  </FormItem>

                  <Button type="primary" style={{ marginBottom: '5px', float: 'right' }} onClick={this.handleClick} disabled={this.state.mode === 'edit' ? true : false} >Add</Button>

                </Col>
              </Row>

            </Form>

            <Table dataSource={this.state.dataSource} columns={columns} />

          </Card>
        </Spin>
      </Layout>
    )
  }
}


function mapStateToProps(state) {
  return {
    receipts: state.receipts,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchReceipts: fetchReceipts,
    pushReceipts: pushReceipts,
    removeReceipts: removeReceipts,
    updateActiveReceipts: updateActiveReceipts,
    updateReceipts: updateReceipts,
    updateMode: updateMode
  }, dispatch);
}

export default requireAuth(connect(mapStateToProps, mapDispatchToProps)(Form.create()(ReceiptsForm)));
